export const customSettings = {
	pagescroll: {
		threshold: 100
	},
	ndssearch: {
		pageheaderHeight: '48px'
	}
};

// Links im Menü klickbar machen wenn wir mobil sind
var menuLevel1Links = document.getElementsByClassName('menu__link-level--1');
for (var i = 0; i < menuLevel1Links.length; i++) {
  menuLevel1Links[i].addEventListener('click', (event) => {
    if(window.innerWidth < 768) {
      event.currentTarget.parentElement.getElementsByTagName('button')[0].click();
    }
  }, false);
}

// Hole das Element mit der Klasse "media-item"
const mediaItems = document.querySelectorAll('.media-item__link');

// Füge für jedes "media-item"-Element einen Event-Listener hinzu
mediaItems.forEach(item => {
  // Wenn das "media-item"-Element den Fokus bekommt
  item.addEventListener('focus', () => {
    // Hole den Elternelement (Parent) mit der Klasse "media-gallery__item"
    const parent = item.closest('.media-gallery__item');
    if (parent) {
      parent.classList.add('onFocus'); // Füge die Klasse "onFocus" hinzu
    }
  });

  // Wenn das "media-item"-Element den Fokus verliert
  item.addEventListener('blur', () => {
    // Hole den Elternelement (Parent) mit der Klasse "media-gallery__item"
    const parent = item.closest('.media-gallery__item');
    if (parent) {
      parent.classList.remove('onFocus'); // Entferne die Klasse "onFocus"
    }
  });
});
